export interface Article {
  id: string;
  slug: string;
  title: string;
  category: string;
  categorySlug: string;
  description: string;
  content: string;
  image: string;
  rating: number;
  year: number;
  genre: string[];
  director: string;
  cast: string[];
  duration: string;
  isHot: boolean;
  isNew: boolean;
  publishDate: string;
  views: number;
}

export const categories = [
  { name: '电影', slug: 'movie', icon: 'ri-film-line' },
  { name: '电视剧', slug: 'tv', icon: 'ri-tv-line' },
  { name: '综艺', slug: 'variety', icon: 'ri-live-line' },
  { name: '动漫', slug: 'anime', icon: 'ri-rocket-line' },
  { name: '纪录片', slug: 'documentary', icon: 'ri-camera-line' },
];

export const articles: Article[] = [
  {
    id: '1',
    slug: 'liu-lang-di-qiu-3',
    title: '流浪地球3：星辰彼岸',
    category: '电影',
    categorySlug: 'movie',
    description: '太阳危机降临，人类面临前所未有的挑战。新一代宇航员踏上星际征程，寻找人类新家园的史诗级科幻巨制。',
    content: '<p>在《流浪地球3：星辰彼岸》中，人类文明面临着更加严峻的考验。地球发动机持续运转，但宇宙深处的未知威胁正在逼近。</p><p>本片由郭帆导演再度执导，集结了吴京、刘德华等原班人马，同时引入新生代演员阵容。影片在视觉特效上实现了全面突破，打造出令人叹为观止的宇宙奇观。</p><p>故事承接前作，当地球驶入更加危险的宇宙区域时，人类不仅要面对恶劣的太空环境，还要应对来自未知文明的潜在威胁。新一代宇航员将肩负起守护人类文明的使命，展开一场跨越星辰的史诗冒险。</p><h3>影片亮点</h3><p>本片在科幻设定上更加宏大，情感内核更加深刻。导演郭帆表示："我们希望不仅展现科技的进步，更要展现人性在极端环境下的光辉。"</p><p>特效团队采用了全新的渲染技术，宇宙场景的逼真度达到了国际顶尖水平。配乐由汉斯·季默操刀，为影片增添了震撼人心的力量。</p>',
    image: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20sci-fi%20movie%20poster%20with%20astronaut%20in%20space%20suit%20looking%20at%20distant%20galaxy%2C%20earth%20in%20background%2C%20cinematic%20lighting%2C%20dramatic%20composition%2C%20warm%20orange%20and%20deep%20blue%20tones%2C%20movie%20poster%20style%20with%20clean%20background&width=800&height=1120&seq=movie-1&orientation=portrait',
    rating: 9.2,
    year: 2025,
    genre: ['科幻', '冒险', '灾难'],
    director: '郭帆',
    cast: ['吴京', '刘德华', '李雪健', '沙溢', '宁理'],
    duration: '148分钟',
    isHot: true,
    isNew: true,
    publishDate: '2025-07-15',
    views: 1289000,
  },
  {
    id: '2',
    slug: 'man-jiang-hong-2',
    title: '满江红2：山河令',
    category: '电影',
    categorySlug: 'movie',
    description: '南宋绍兴年间，一场惊天阴谋在临安城悄然展开。忠义之士血染山河，一曲满江红再次响彻云霄。',
    content: '<p>《满江红2：山河令》延续了前作的悬疑探案风格，将故事舞台扩展至更加宏大的历史背景中。</p><p>张艺谋导演在本片中融合了传统戏曲元素与现代电影语言，打造出独树一帜的视觉风格。沈腾、易烊千玺、张译、雷佳音等实力派演员的精彩演绎，让这部历史悬疑片充满了张力与魅力。</p><p>影片讲述了一群身份各异的小人物，在民族危亡之际挺身而出，用智慧和勇气守护家国山河的感人故事。</p><h3>创作背后</h3><p>张艺谋导演在采访中透露，本片的创作灵感来源于岳飞《满江红》词作中蕴含的爱国情怀与不屈精神。影片通过悬疑叙事的方式，将传统文化精神以全新的视角呈现给当代观众。</p>',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20movie%20poster%20ancient%20Chinese%20warrior%20in%20red%20armor%20standing%20in%20courtyard%2C%20dramatic%20lighting%2C%20cinematic%20style%2C%20warm%20golden%20and%20deep%20red%20tones%2C%20clean%20elegant%20background&width=800&height=1120&seq=movie-2&orientation=portrait',
    rating: 8.8,
    year: 2025,
    genre: ['历史', '悬疑', '剧情'],
    director: '张艺谋',
    cast: ['沈腾', '易烊千玺', '张译', '雷佳音', '岳云鹏'],
    duration: '159分钟',
    isHot: true,
    isNew: false,
    publishDate: '2025-06-20',
    views: 987000,
  },
  {
    id: '3',
    slug: 'chang-an-san-wan-li-2',
    title: '长安三万里2：盛唐风华',
    category: '电影',
    categorySlug: 'movie',
    description: '回到那个诗意盎然的盛唐时代，看李白、杜甫、王维等文豪挥毫泼墨，谱写中华文明最璀璨的篇章。',
    content: '<p>《长安三万里2：盛唐风华》以更加宏大的视角展现了唐朝文化的鼎盛时期。影片通过动画的形式，让观众沉浸式体验那个诗歌飞扬的黄金时代。</p><p>追光动画历时三年精心打磨，在画面质感、人物塑造和文化呈现上都达到了新的高度。影片不仅是一部动画作品，更是一幅展现中华文化之美的壮丽画卷。</p>',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20movie%20poster%20Tang%20dynasty%20poet%20in%20traditional%20robes%20standing%20under%20moonlight%2C%20ancient%20Chinese%20architecture%2C%20poetic%20atmosphere%2C%20ink%20wash%20painting%20style%2C%20elegant%20golden%20tones&width=800&height=1120&seq=movie-3&orientation=portrait',
    rating: 9.0,
    year: 2025,
    genre: ['动画', '历史', '文艺'],
    director: '谢君伟',
    cast: ['杨天翔', '凌振赫', '吴俊全'],
    duration: '168分钟',
    isHot: true,
    isNew: true,
    publishDate: '2025-07-28',
    views: 756000,
  },
  {
    id: '4',
    slug: 'kuang-biao-zhi-feng-bao-zai-qi',
    title: '狂飙之风暴再起',
    category: '电视剧',
    categorySlug: 'tv',
    description: '扫黑除恶行动持续深入，一场更大的较量在暗中展开。安欣与高启强的故事迎来全新篇章。',
    content: '<p>《狂飙之风暴再起》作为现象级剧集《狂飙》的续作，延续了前作紧张刺激的叙事风格和深刻的社会洞察。</p><p>张译、张颂文再次携手，在新篇章中诠释更加复杂的人物关系和命运纠葛。剧情在扫黑除恶的大背景下，深入探讨了人性的光明与黑暗。</p><h3>制作规模</h3><p>本剧集在制作规模上全面升级，拍摄周期长达八个月，辗转十余个城市取景。导演徐纪周表示，希望通过对细节的极致追求，为观众呈现一部经得起时间考验的精品力作。</p>',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20TV%20series%20poster%2C%20two%20men%20in%20dark%20suits%20facing%20each%20other%20in%20rainy%20street%2C%20noir%20cinematography%2C%20deep%20shadows%2C%20dramatic%20tension%2C%20modern%20Chinese%20city%20night%20scene&width=800&height=1120&seq=tv-1&orientation=portrait',
    rating: 9.5,
    year: 2025,
    genre: ['犯罪', '剧情', '悬疑'],
    director: '徐纪周',
    cast: ['张译', '张颂文', '李一桐', '吴刚', '张志坚'],
    duration: '40集',
    isHot: true,
    isNew: false,
    publishDate: '2025-05-10',
    views: 2560000,
  },
  {
    id: '5',
    slug: 'da-feng-da-geng-ren',
    title: '大奉打更人',
    category: '电视剧',
    categorySlug: 'tv',
    description: '现代打工人穿越到大奉王朝，凭借现代知识和推理能力，在诡异案件中屡破奇案，步步高升的精彩故事。',
    content: '<p>《大奉打更人》改编自卖报小郎君同名小说，由王鹤棣、田曦薇领衔主演。剧集融合了悬疑探案、朝堂权谋和轻松喜剧元素。</p><p>主人公许七安意外穿越到大奉王朝，成为一名打更人。凭借现代人的思维方式和丰富的知识储备，他在一系列离奇案件中展现出惊人的推理能力。</p><h3>角色塑造</h3><p>王鹤棣在本剧中展现了全新的表演风格，将许七安这个角色的机智幽默与深沉内涵完美融合。田曦薇饰演的怀庆公主则为剧集增添了浪漫色彩。</p>',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20costume%20drama%20poster%2C%20handsome%20male%20lead%20in%20ancient%20Chinese%20official%20robe%20holding%20lantern%20in%20misty%20ancient%20street%2C%20mysterious%20atmosphere%2C%20warm%20golden%20lantern%20light&width=800&height=1120&seq=tv-2&orientation=portrait',
    rating: 8.9,
    year: 2025,
    genre: ['古装', '悬疑', '喜剧'],
    director: '邓科',
    cast: ['王鹤棣', '田曦薇', '刘奕君', '晏紫东'],
    duration: '36集',
    isHot: true,
    isNew: true,
    publishDate: '2025-07-20',
    views: 1890000,
  },
  {
    id: '6',
    slug: 'fan-hua-si-ji',
    title: '繁花似锦',
    category: '电视剧',
    categorySlug: 'tv',
    description: '九十年代上海，黄河路上风云变幻。一段关于梦想、爱情与奋斗的都市传奇徐徐展开。',
    content: '<p>《繁花似锦》延续了王家卫导演标志性的美学风格，以细腻的光影和深情的叙事描绘了九十年代上海的都市风情。</p><p>胡歌在本剧中贡献了令人难忘的表演，将那个时代年轻人的激情与迷茫诠释得淋漓尽致。剧集在还原年代感上做到了极致，从服装道具到街景布置，每一个细节都经过精心设计。</p>',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20poster%201990s%20Shanghai%2C%20elegant%20man%20in%20vintage%20suit%20standing%20on%20busy%20neon-lit%20street%2C%20nostalgic%20cinematography%2C%20warm%20golden%20and%20deep%20green%20tones&width=800&height=1120&seq=tv-3&orientation=portrait',
    rating: 9.3,
    year: 2025,
    genre: ['都市', '剧情', '年代'],
    director: '王家卫',
    cast: ['胡歌', '马伊琍', '唐嫣', '辛芷蕾'],
    duration: '30集',
    isHot: false,
    isNew: false,
    publishDate: '2024-12-27',
    views: 3200000,
  },
  {
    id: '7',
    slug: 'cheng-feng-po-lang-di-wu-ji',
    title: '乘风破浪第五季',
    category: '综艺',
    categorySlug: 'variety',
    description: '华语乐坛顶级女艺人集结，用舞台诠释不被定义的人生。全新赛制，更多惊喜，燃爆今夏。',
    content: '<p>《乘风破浪第五季》以更加强大的嘉宾阵容和创新的赛制设计回归。本季汇集了来自不同年代、不同风格的三十位女艺人，她们将在这个舞台上重新定义自我。</p><p>节目在舞美设计上投入巨大，每一场公演都堪称视听盛宴。赛制的创新也为节目增添了更多悬念和看点。</p><h3>社会意义</h3><p>节目不止是一场才艺比拼，更是对女性力量的生动诠释。每一位姐姐都在用自己的方式告诉观众：年龄从不是限制，勇气和热爱才是人生的底色。</p>',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%2C%20group%20of%20elegant%20women%20on%20glamorous%20stage%20with%20sparkling%20lights%2C%20empowering%20atmosphere%2C%20luxurious%20golden%20and%20rose%20tones%2C%20entertainment%20show%20style&width=800&height=1120&seq=variety-1&orientation=portrait',
    rating: 8.7,
    year: 2025,
    genre: ['音乐', '真人秀', '竞演'],
    director: '吴梦知',
    cast: ['宁静', '那英', '王心凌', '于文文', '刘恋'],
    duration: '12期',
    isHot: true,
    isNew: true,
    publishDate: '2025-07-05',
    views: 4560000,
  },
  {
    id: '8',
    slug: 'hai-zei-wang-xin-pian',
    title: '海贼王：终焉之岛',
    category: '动漫',
    categorySlug: 'anime',
    description: '路飞与伙伴们抵达最终之岛，ONE PIECE的秘密即将揭晓。二十余年的冒险史诗迎来最激动人心的高潮。',
    content: '<p>《海贼王：终焉之岛》是这部陪伴了无数人成长的动漫系列的终章电影。路飞和他的草帽海贼团终于抵达了传说中的最终之岛拉夫德鲁。</p><p>影片在制作上达到了剧场版动画的巅峰水准，战斗场面的流畅度和震撼力令人叹为观止。尾田荣一郎亲自参与剧本创作，确保了这个结局能够不负粉丝二十余年的等待。</p>',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20movie%20poster%20pirate%20crew%20standing%20on%20ship%20facing%20mysterious%20island%20at%20sunset%2C%20epic%20adventure%20atmosphere%2C%20warm%20golden%20sunset%20colors%2C%20anime%20art%20style&width=800&height=1120&seq=anime-1&orientation=portrait',
    rating: 9.7,
    year: 2025,
    genre: ['冒险', '热血', '动作'],
    director: '尾田荣一郎',
    cast: ['田中真弓', '中井和哉', '冈村明美'],
    duration: '135分钟',
    isHot: true,
    isNew: false,
    publishDate: '2025-06-01',
    views: 5670000,
  },
  {
    id: '9',
    slug: 'di-qiu-mai-dong',
    title: '地球脉动第三季',
    category: '纪录片',
    categorySlug: 'documentary',
    description: 'BBC史诗级自然纪录片震撼回归，用8K超高清镜头捕捉地球上最令人惊叹的生命奇迹。',
    content: '<p>《地球脉动第三季》历时四年制作，摄制组跨越四十余个国家，用最先进的拍摄技术记录下自然界最壮观的画面。</p><p>本季聚焦于人类活动对自然界的影响，以及动物们如何在不断变化的环境中适应和生存。每一个镜头都是对生命的礼赞，也是对环境保护的呼唤。</p>',
    image: 'https://readdy.ai/api/search-image?query=Nature%20documentary%20poster%20with%20majestic%20mountain%20landscape%20and%20wildlife%20silhouettes%2C%20golden%20sunset%20light%2C%20cinematic%20aerial%20photography%20style%2C%20warm%20earth%20tones&width=800&height=1120&seq=doc-1&orientation=portrait',
    rating: 9.8,
    year: 2025,
    genre: ['自然', '纪录', '科教'],
    director: '大卫·爱登堡',
    cast: ['大卫·爱登堡'],
    duration: '8集',
    isHot: false,
    isNew: true,
    publishDate: '2025-07-10',
    views: 2340000,
  },
  {
    id: '10',
    slug: 'gu-dao-jing-hun',
    title: '孤岛惊魂',
    category: '电影',
    categorySlug: 'movie',
    description: '一群年轻人在荒岛度假时遭遇神秘事件，生存与信任的双重考验。国产悬疑惊悚片的全新突破。',
    content: '<p>《孤岛惊魂》是国产悬疑惊悚类型的一次大胆尝试。影片将密闭空间的心理压迫感与超自然元素巧妙结合，营造出令人窒息的观影体验。</p><p>导演在片中展现了出色的类型把控能力，节奏紧凑，反转不断。演员们在极端情境下的表演也令人印象深刻。</p>',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20thriller%20movie%20poster%2C%20dark%20mysterious%20island%20at%20night%20with%20full%20moon%2C%20silhouette%20of%20person%20standing%20on%20cliff%2C%20suspenseful%20atmosphere%2C%20deep%20shadows%2C%20cinematic%20horror%20style&width=800&height=1120&seq=movie-4&orientation=portrait',
    rating: 8.3,
    year: 2025,
    genre: ['悬疑', '惊悚', '冒险'],
    director: '陈思诚',
    cast: ['刘昊然', '张子枫', '肖央', '文咏珊'],
    duration: '118分钟',
    isHot: false,
    isNew: true,
    publishDate: '2025-07-25',
    views: 654000,
  },
  {
    id: '11',
    slug: 'qing-yu-nian-di-er-ji',
    title: '庆余年第二季',
    category: '电视剧',
    categorySlug: 'tv',
    description: '范闲归来，京都风云再起。权谋与情感的终极对决，让无数剧迷翘首以盼的续作终于上线。',
    content: '<p>《庆余年第二季》承接第一季结尾，范闲在经历生死考验后重返京都。更加复杂的朝堂斗争和更加深刻的情感纠葛让本季的故事张力十足。</p><p>张若昀在本季中的表演更加成熟，将范闲这一角色的成长与蜕变诠释得入木三分。李沁、陈道明等演员的回归也为剧集增色不少。</p>',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20costume%20drama%20poster%2C%20elegant%20man%20in%20traditional%20hanfu%20robe%20standing%20in%20ancient%20palace%20hall%2C%20cinematic%20lighting%2C%20warm%20golden%20and%20deep%20red%20tones%2C%20period%20drama%20style&width=800&height=1120&seq=tv-4&orientation=portrait&nocache=true',
    rating: 9.1,
    year: 2025,
    genre: ['古装', '权谋', '剧情'],
    director: '孙皓',
    cast: ['张若昀', '李沁', '陈道明', '吴刚', '郭麒麟'],
    duration: '36集',
    isHot: false,
    isNew: false,
    publishDate: '2024-05-16',
    views: 4560000,
  },
  {
    id: '12',
    slug: 'hai-kuo-tian-kong',
    title: '海阔天空',
    category: '综艺',
    categorySlug: 'variety',
    description: '六位音乐人踏上环游中国的音乐之旅，在旅途中寻找灵感，创作打动人心的原创歌曲。',
    content: '<p>《海阔天空》是一档原创音乐旅行综艺，节目邀请了六位风格迥异的音乐人，他们将在中国的不同城市和自然景观中寻找音乐灵感。</p><p>每一期节目都是一次音乐与旅行的完美融合，音乐人们不仅要面对创作挑战，还要融入当地文化，与普通百姓互动交流。</p>',
    image: 'https://readdy.ai/api/search-image?query=Music%20travel%20variety%20show%20poster%2C%20musicians%20with%20instruments%20on%20scenic%20mountain%20road%20at%20sunset%2C%20road%20trip%20vibe%2C%20warm%20natural%20lighting%2C%20cinematic%20style&width=800&height=1120&seq=variety-2&orientation=portrait',
    rating: 8.5,
    year: 2025,
    genre: ['音乐', '旅行', '真人秀'],
    director: '严敏',
    cast: ['周深', '毛不易', '邓紫棋', '李荣浩', '郭顶', '陈粒'],
    duration: '10期',
    isHot: false,
    isNew: true,
    publishDate: '2025-07-18',
    views: 1230000,
  },
];